import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { FormsQueryKeys } from '../queries'

export interface UseAvailableFormsHookProps {
  allForms?: boolean
  folderId?: number | undefined
  enabled?: boolean
}

const useAvailableForms = ({ allForms = false, folderId, enabled = true }: UseAvailableFormsHookProps) => {
  const { mainApi: api } = useApi()

  const query = useQuery({
    queryFn: () => api.forms.getFormsListForCurrentUserAsync({ folderId, allForms }),
    queryKey: [FormsQueryKeys.AvailableForms, folderId, allForms],
    enabled,
  })

  return {
    fetching: query.isFetching,
    loading: query.isLoading,
    forms: query.data ?? [],
    onReload: query.refetch,
  }
}

export default useAvailableForms
